export const REWARDS = [
  'IsGoodValue',
  'IsGrowingProfitOrRevenue',
  'HasBeenGrowingProfitOrRevenue',
  'IsGoodRelativeValue',
  'IsTradingBelowAnalystPriceTargets',
  'IsDividendAttractive',
];
export const RISKS = [
  'IsAbleToAchieveProfitability',
  'AreRevenueAndEarningsExpectedToGrow',
  'IsInAGoodFinancialPosition',
  'IsDividendSustainable',
  'HasStableSharePriceOverPast3Months',
  'HasHighQualityEarnings',
  'HasNetProfitMarginImprovedOverPastYear',
  'HasSufficientFinancialData',
  'HasNoConcerningRecentEvents',
  'HasNoSubstantialInsiderSellingOverPastQuarter',
  'HasNotDilutedOverPastYear',
  'HasMeaningfulRevenue',
  'HasMeaningfulMarketCap',
  'HasNoNegativeEquity',
];
